let resolveReady;

export const footerReady = new Promise((resolve) => {
  resolveReady = resolve;
});

export function markFooterReady(udexFooter) {
  resolveReady(udexFooter);
}
